import countries from './countriesSAP';

const EUROPE = 'Europe';

/**
 * @name getAllowedShipToCountries
 * @desc Determine which countries an account can ship/save addresses to, based on the account's
 * sold-to/SAP country. Sales org determines which distribution center (DC) serves an account, and
 * some DCs (e.g. the EMEA DC, sales org 2000) serve multiple countries out of one location:
 *   - Europe-region accounts in a shared-DC sales org may ship to any Europe-region country in
 *     that sales org.
 *   - Africa/Middle-East-region accounts in a shared-DC sales org may ship to their own country
 *     plus any Europe-region country in that sales org (but not other Africa/Middle-East
 *     countries - those aren't served from the same DC as each other).
 * Countries with no `salesOrgCode` tag keep the original behavior: restricted to just that one
 * sold-to country.
 * @param {String} accountCountryCode the code2 of the account's sold-to/SAP country
 * @returns {Array} the countriesSAP entries the account may ship/save addresses to
 */
const getAllowedShipToCountries = accountCountryCode => {
  const accountCountry = countries.find(country => country.code2 === accountCountryCode);
  if (!accountCountry) return [];

  if (!accountCountry.salesOrgCode) return [accountCountry];

  const europeCountries = countries.filter(
    country => country.salesOrgCode === accountCountry.salesOrgCode && country.shipRegion === EUROPE
  );

  if (accountCountry.shipRegion === EUROPE) return europeCountries;

  return [accountCountry, ...europeCountries];
};

export default getAllowedShipToCountries;
